"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiUtils = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var ApiUtilsConfigSetup_1 = require("./config/ApiUtilsConfigSetup");
var ApiUtils = /** @class */ (function (_super) {
    __extends(ApiUtils, _super);
    function ApiUtils(core) {
        return _super.call(this, ApiUtils.moduleName, core) || this;
    }
    ApiUtils.create = function (core) {
        return new ApiUtils(core !== null && core !== void 0 ? core : common_core_1.CoreProvider.getDefault());
    };
    ApiUtils.prototype.setup = function () {
        ApiUtilsConfigSetup_1.ApiUtilsConfigSetup.register(this.core.config);
    };
    ApiUtils.prototype.start = function () {
        // Nothing...
    };
    ApiUtils.moduleName = 'api';
    return ApiUtils;
}(common_core_1.Module));
exports.ApiUtils = ApiUtils;
//# sourceMappingURL=ApiUtils.js.map